<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-23 18:16:26
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-24 19:17:27
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/promoteGoodsDrawer/promoteGoodsDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-drawer title="推广商品" :size="600" :wrapperClosable="false" :append-to-body="true" :visible.sync="visible" class="drawer" @close="onClose">
		<div class="drawer-content">
			<div class="tips">
				<i class="el-icon-info icon-info mr-4"></i>
				<div class="tips-right font-h6-regular"
					>确认推广后商品将按照以下机制自动报名并审核通过指定的团长活动，商品的认领人默认为操作人。如该商品商家设置了“商团协同”，将自动绑定您与商家的的商团协同</div
				>
			</div>
			<Panel :contentPadding="24" class="mt-12">
				<div class="flex flex-just-between">
					<div class="card-left mr-8">
						<img :src="info.productPic" alt="" />
					</div>
					<div class="card-right flex-1">
						<div class="flex flex-align-center">
							<platform-icon style="flex-shrink: 0" class="mr-4" :platformId="info.platformId"></platform-icon>
							<div :class="['platform-tag', 'mr-4', 'fz-12', merchantGoods ? 'merchant-active' : '']">{{
								merchantGoods ? '商家' : '团长' | formatEmpty
							}}</div>
							<rd-text class="card-title fz-14 pointer" width="376">{{ info.outerProductName | formatEmpty }}</rd-text>
						</div>
						<div class="flex flex-align-center fz-12 outer-product-id"> ID {{ info.outerProductId | formatEmpty }} </div>
						<div class="price-stock-rate flex flex-align-center">
							<div class="price fz-12 mr-12">售价：{{ info.salePrice | formatPrice }}</div>
							<div class="stock fz-12 mr-12">库存：{{ info.stockNum | formatEmpty | formatPrice2 }}</div>
							<div class="rate fz-12 mr-12">普通佣金率：{{ info.baseCommissionRate }}%</div>
							<div class="rate fz-12"
								>{{ deadCommission ? '达人佣金率：' : '总佣金率：' }} {{ deadCommission ? info.talentCommission : info.commissionRate }}%</div
							>
						</div>
						<div class="shop-info-timer flex flex-align-center">
							<div class="mr-12 shop-info fz-12">店铺：{{ info.outerShopName | formatEmpty }}</div>
							<div class="fz-12 timer-info">推广截止时间：{{ info.promotionEndTime | formatEmpty }}</div>
						</div>
						<div class="source-relation flex flex-align-center">
							<div v-if="info.tenantName" class="source-commander fz-12 mr-12">来源团长：{{ info.institutionName | formatEmpty }}</div>
							<div class="relation fz-12 mr-12">联系方式：{{ info.mobile | formatEmpty }}</div>
						</div>
					</div>
				</div>
			</Panel>
			<Panel :el-formcontentPadding="24" class="mt-12">
				<div class="promotional-information">
					<div class="title fz-14">推广信息</div>
				</div>
				<el-form class="mt-20" label-position="left" label-width="110px" :model="informationForm" ref="informationForm" :rules="verifyRules">
					<el-form-item label="授权团长" prop="authorityId">
						<commander-select
							style="width: 240px"
							:key="platformId"
							:platformId="platformId"
							v-model="informationForm['authorityId']"
							:show-all="true"
							@change="commanderChange"
						></commander-select>
					</el-form-item>
					<el-form-item v-if="informationForm['authorityId']" label="活动" prop="activityId">
						<activity-select
							ref="activitySelect"
							style="width: 240px"
							:platformId="platformId"
							:authorityId="informationForm['authorityId']"
							v-model="informationForm.activityId"
						></activity-select>
					</el-form-item>
					<el-form-item class="" label="服务费率" prop="serviceFeeRate">
						<el-input
							class="rate-input"
							placeholder="请输入服务费率"
							type="number"
							style="width: 240px"
							@input="onRateInput()"
							:disabled="deadCommission"
							v-model="informationForm.serviceFeeRate"
							:value="informationForm.serviceFeeRate"
						>
							<template slot="append">%</template></el-input
						>
					</el-form-item>
					<el-form-item label="达人佣金率" prop="talentCommission">
						<el-input
							type="number"
							placeholder="请输入达人佣金率"
							style="width: 240px"
							class="rate-input"
							v-model="informationForm.talentCommission"
							:value="informationForm.talentCommission"
							:disabled="deadCommission"
						>
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
					<el-form-item label="合作结束时间" prop="cooperationEndTime" v-if="deadCommission && $isKs()">
						<el-date-picker
							v-model="informationForm['cooperationEndTime']"
							style="width: 240px"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="选择日期"
						>
						</el-date-picker>
					</el-form-item>
				</el-form>
			</Panel>
		</div>
		<div class="drawer-bottom flex flex-align-center flex-just-end">
			<el-button @click="onClose">取消</el-button>
			<el-button :loading="loading" class="mr-16" @click="submit" type="primary">提交</el-button>
		</div>
	</el-drawer>
</template>
<script>
import debounce from 'lodash/debounce';
import commanderSelect from '@/components/commanderSelect/index.vue';
import activitySelect from '@/components/activitySelect/activitySelect.vue';
import { productAdd, productCommonList } from '@/api/shopManage';
export default {
	components: {
		commanderSelect,
		activitySelect,
	},
	data() {
		return {
			visible: false,
			info: {},
			informationForm: {
				activityId: '', //活动Id
				authorityId: '', //机构Id
				talentCommission: '', // 服务费率
				serviceFeeRate: '', //达人佣金率
				cooperationEndTime: '', //合作结束时间
			},
			platformId: '',
			productCommonId: '',
			rulesObj: {
				authorityId: [{ required: true, message: '请选择团长', trigger: 'blur' }, { type: 'string' }],
			},
			loading: false,
		};
	},
	computed: {
		deadCommission() {
			return +this.info.commissionType === +newDataMap.SHOP_MANAGE.DEAD_COMMISSION.value;
		},
		merchantGoods() {
			return +this.info.appType === +newDataMap.SHOP_MANAGE.MERCHANDISE_GOODS.value;
		},
		verifyRules({ deadCommission }) {
			let rulesObj = {};
			const rulesArr = [
				{ show: true, value: [{ required: true, message: '请选择团长', trigger: 'blur' }, { type: 'string' }], key: 'authorityId' },
				{ show: true, value: [{ required: true, message: '请选择活动', trigger: 'blur' }, { type: 'string' }], key: 'activityId' },
				{
					show: deadCommission,
					value: [{ required: true, message: '请输入服务费率', trigger: 'blur' }, { type: 'string' }],
					key: 'talentCommission',
				},
				{ show: deadCommission, value: [{ required: true, message: '请输入佣金率', trigger: 'blur' }, { type: 'string' }], key: 'serviceFeeRate' },
				{
					show: deadCommission && this.$isKs(this.platformId),
					value: [{ required: true, message: '请选择合作结束时间', trigger: 'blur' }, { type: 'string' }],
					key: 'cooperationEndTime',
				},
			];
			rulesArr.map(val => {
				if (val.show) {
					rulesObj[val.key] = val.value;
				}
			});

			return rulesObj;
		},
	},
	methods: {
		async getInfo() {
			const { productCommonId, platformId } = this;
			const { data } = await productCommonList({ productCommonId, platformId });
			this.info = data.list[0];
		},
		show(info, platformId) {
			this.visible = true;
			this.platformId = platformId;
			this.productCommonId = info.productCommonId;
			this.info = info;
			this.informationForm.serviceFeeRate = info.serviceFeeRate === '0.00' ? '' : info.serviceFeeRate;
			this.informationForm.talentCommission = info.serviceFeeRate === '0.00' ? '' : info.talentCommission;
		},
		commanderChange() {
			this.$nextTick(() => {
				if (this.$refs.activitySelect) {
					this.$refs.activitySelect.clear();
					this.$refs.activitySelect.getActivityList();
				}
			});
		},
		submit: debounce(function () {
			this.$refs.informationForm.validate(async valid => {
				if (valid) {
					const { auditStatus, commissionType, id, talentCommission: talentCommissionBefore, serviceRate: serviceFeeRateBefore } = this.info;
					const {
						serviceFeeRate: serviceFeeRateAfter,
						talentCommission: talentCommissionAfter,
						activityId,
						authorityId,
						cooperationEndTime,
					} = this.informationForm;
					if (!this.deadCommission && +this.informationForm.serviceFeeRate + +this.informationForm.talentCommission > this.info.commissionRate) {
						this.$message.error('输入的服务率和达人佣金率之和不能大于总佣金率');
						return;
					}
					let order = {
						commissionType,
						serviceFeeRate: serviceFeeRateBefore,
						talentCommission: talentCommissionBefore,
						auditStatus,
					};
					let params = {
						id,
						serviceFeeRate: serviceFeeRateAfter,
						talentCommission: talentCommissionAfter,
						activityId,
						authorityId,
						platformId: this.platformId,
						// cooperationEndTime 只有快手存在这个参数
						cooperationEndTime: this.deadCommission && this.$isKs(this.platformId) ? cooperationEndTime + ' 00:00:00' : undefined, //来自商家的商品不需要传这个字段
					};
					try {
						this.loading = true;
						const { data, code } = await productAdd({ ...params, order });
						if (code !== 0) return;
						if (data.code === 0) {
							this.visible = false;
							this.$message.success(data.msg);
						} else {
							this.getInfo();
							this.$message.error(data.msg);
						}
					} finally {
						this.loading = false;
					}
				}
			});
		}, 500),
		onClose() {
			this.informationForm = {
				activityId: '',
				authorityId: '',
				talentCommission: '', // 服务费率
				serviceFeeRate: '', //达人佣金率
				cooperationEndTime: '',
			};
			this.visible = false;
		},
		onRateInput() {
			if (this.informationForm.serviceFeeRate == '') {
				this.informationForm.serviceFeeRate = '';
				return;
			}
			const regexStr = `\\d+\\.?\\d{0,${+this.platformId === 1 ? 2 : 1}}`;
			this.informationForm.serviceFeeRate = +this.informationForm.serviceFeeRate.match(regexStr);
		},
	},
};
</script>
<style lang="less" scoped>
.drawer {
	/deep/ .el-drawer__body {
		background: @color-gy2;
	}
	.drawer-content {
		padding: 16px 16px 64px 24px;
		.tips {
			display: flex;
			padding: 12px 16px 12px 16px;
			border-radius: 8px;
			border: 1px solid #ffe2d7;
			background: rgba(255, 240, 235, 0.5);
			.icon-info {
				position: relative;
				top: 3px;
				color: @color-o;
				font-size: 14px;
			}
			.tips-right {
				color: @color-gy9;
			}
		}
		.card-left {
			width: 68px;
			height: 68px;
			img {
				border-radius: 4px;
			}
		}
		.merchant-active {
			border: 1px solid @color-p2 !important;
			color: @color-p4 !important;
		}
		.card-right {
			.platform-tag {
				min-width: 32px;
				border-radius: 2px;
				box-sizing: border-box;
				padding: 0 3px 0 3px;
				height: 16px;
				line-height: 15px;
				border: 1px solid @color-b2;
				color: @color-b4;
			}
			.card-title {
				color: @color-gy9;
				line-height: 20px;
			}
			.outer-product-id {
				color: @color-gy8;
				line-height: 20px;
			}
			.price-stock-rate {
				.price,
				.stock,
				.rate {
					line-height: 20px;
					color: @color-text-regular;
				}
			}
			.shop-info-timer {
				.shop-info {
					color: @color-text-regular;
					line-height: 20px;
				}
				.timer-info {
					color: @color-text-regular;
					line-height: 20px;
				}
			}
			.source-commander,
			.relation {
				color: @color-text-regular;
				line-height: 20px;
			}
		}
		.promotional-information {
			.title {
				color: @color-gy9;
				line-height: 24px;
				font-family: 'PingFangSC-Semibold';
			}
		}
	}
	.rate-input {
		/deep/ .el-input__inner {
			border-right-color: transparent !important;
			border-color: @color-gy5;
		}
		/deep/ .el-input-group__append {
			color: @color-gy9;
		}
		/deep/ .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			appearance: none;
		}
		/deep/ .el-input__inner[type='number'] {
			-moz-appearance: textfield;
		}
	}
	.drawer-bottom {
		width: 100%;
		height: 64px;
		background: @color-white;
		position: absolute;
		bottom: 0px;
		right: 0px;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
	}
}
</style>
